import template from './mx-shell-toolbar-navigation.html';

export const mxShellToolbarNavigationComponent = {
	bindings: {},
	controller: MxShellToolbarNavigationController,
	controllerAs: 'vm',
	template: template,
};

MxShellToolbarNavigationController.$inject = ['$scope', 'mx.shell.EventService', 'mx.shell.ToolbarNavigationService'];

function MxShellToolbarNavigationController($scope, eventService, toolbarNavigationService) {
	const vm = this;

	vm.toolbarNavigationService = toolbarNavigationService;
	vm.relinkEvent = mx.shell.EventCodes.ToolbarNavigationLoaded; //event on which component will be re-rendered

	return vm;
}
